import { MxButton } from '@meng-ui-vue/components/button'
import { MxDatavLoading } from '@meng-ui-vue/components/datav-loading'

import type { Plugin } from 'vue'

export default [MxButton, MxDatavLoading] as Plugin[]
